export default __webpack_public_path__ + "static/media/tm.acee921d.svg";